import styled from "styled-components";

export const Padding = styled.div`
padding: ${(props: any) => props.padding || '2'}rem;
`
